
import React, {useContext} from "react";
// reactstrap components
import {
  Row,
  Col,
  FormGroup,
  Card,
  CardImg,
  CardBody,
  CardText,
  CardHeader,
} from "reactstrap";
import rest from "../../../API/api";
import { RegistrationContext } from "../../../context/RegistrationContext";
// TODO: Migrate to @react-google-maps/api when needed
// import {
//   withScriptjs,
//   withGoogleMap,
//   GoogleMap,
//   Marker
// } from "react-google-maps";
import Select from "react-select";

const Step1 = React.forwardRef((props, ref) => {
  // eslint-disable-next-line
  //State from Registration Context
  const [registrationState, setRegistrationState] = useContext(RegistrationContext);
  const [TypeError, setTypeErrorState] = React.useState(null);
  const [EventError, setEventErrorState] = React.useState(null);
  const [MaxRegistrationError, setMaxRegistrationErrorState] = React.useState(null);

  const handleEventChange= async selectedOption => {
    setRegistrationState(registrationState => ({...registrationState, Event: selectedOption }));

    var tempURL = rest.registerreadevent + "/" + selectedOption.value;
    const event = fetch(tempURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json;charset=UTF-8',
        'x-api-key': rest.apiKey
      }),
    });
    const eventResponse = await event;
    const data = await eventResponse.json();
    //Store the event into the Registration Context
    // Initialize questions with empty Value property
    const initializedQuestions = (data.IncludedQuestions || []).map(q => ({
      ...q,
      Value: q.Value || ""
    }));
    setRegistrationState(registrationState => ({
      ...registrationState,
      EventId: data._id,
      EventEnabled: data.Enabled,
      EventImage: data.Image,
      EventImagePublicId: data.ImagePublicId,
      EventTitle: data.Title,
      EventSubTitle: data.SubTitle,
      EventDescription: data.Description,
      EventType: data.Type,
      EventContact: data.Contact,
      EventPhone: data.Phone,
      EventEmail: data.Email,
      EventOtherWebsite: data.OtherWebsite,
      EventLocation: data.Location,
      EventStartDate: data.StartDate,
      EventEndDate: data.EndDate,
      EventAgeRestriction: data.AgeRestriction,
      EventGenderRestriction: data.GenderRestriction,
      EventYoungerThan: data.YoungerThan,
      EventRequireWaivers: data.RequireWaivers,
      EventRequireNameEmail: data.RequireNameEmail,
      EventRequireDOB: data.RequireDOB,
      EventRequireGender: data.RequireGender,
      EventRequirePhone: data.RequirePhone,
      EventIncludeQuestions: data.IncludeQuestions,
      EventIncludedQuestions: initializedQuestions,
      EventRegistrations: data.Registrations,
      EventAcceptOnlineRegistration: data.AcceptOnlineRegistration,
      EventPrice: data.Price,
      EventMaxRegistrations: data.MaxRegistrations,
      EventAfterSubmit: data.AfterSubmit,
    }));
    };



  const handleTypeChange = async selectedOption => {
    setRegistrationState(registrationState => ({...registrationState, Type: selectedOption }));
    //Lets load the events from Mongo
    var temp_array = [];
    //Let's go get the events using the non logged in user API key and return the events of this type
    //Lastly, lets load them into an array that we can then display in a single item pick list
    var tempURL = rest.registerlistevents + "/" + selectedOption.value;
    const eventList = fetch(tempURL, {
      method: 'GET',
      headers: new Headers({
        'Content-Type': 'application/json;charset=UTF-8',
        'x-api-key': rest.apiKey
      }),
    });
    const eventsResponse = await eventList;
    const eventsResult = await eventsResponse.json();
    eventsResult.forEach((event) => {
      //check to be sure the event is Enabled
      temp_array.push({
        value: event._id,
        label: event.Title
      });
    });
    //Now set the state for the EventsList and EventListDisabled
    setRegistrationState(registrationState => ({...registrationState, EventListDisabled: false }));
    setRegistrationState(registrationState => ({...registrationState, eventsList: temp_array }));
    setRegistrationState(registrationState => ({
      ...registrationState,
      EventId: "",
      Event: "",
      EventEnabled: false,
      EventImage: "",
      EventImagePublicId: "",
      EventTitle: "",
      EventSubTitle: "",
      EventDescription: "",
      EventType: "",
      EventContact: "",
      EventPhone: "",
      EventEmail: "",
      EventOtherWebsite: "",
      EventLocation: "",
      EventStartDate: "",
      EventEndDate: "",
      EventAgeRestriction: "",
      EventGenderRestriction: "",
      EventYoungerThan: "",
      EventRequireWaivers: false,
      EventRequireNameEmail: false,
      EventRequireDOB: false,
      EventRequireGender: false,
      EventRequirePhone: false,
      EventIncludeQuestions: false,
      EventIncludedQuestions: [],
      EventAcceptOnlineRegistration: false,
      EventPrice: 0,
      EventAfterSubmit: "",
    }));
  };

  /*eslint-disable-next-line*/
  const isValidated = () => {
    //const userInput = this._grabUserInput(); // grab user entered vals
    ((registrationState.Type === "") || (registrationState.Type === null))
        ? setTypeErrorState(
              <small className="text-danger">
                Please select what type of event you are registering for.
              </small>
          )
        : setTypeErrorState(null);
    var type = ((registrationState.Type !== "") && (registrationState.Type !== null));

    ((registrationState.Event === "") || (registrationState.Event === null))
        ? setEventErrorState(
              <small className="text-danger">
                Please select what event you are registering for.
              </small>
          )
        : setEventErrorState(null);
    var event = ((registrationState.Event !== "") && (registrationState.Event !== null));

//Check to see if the current event is full
    (registrationState.EventMaxRegistrations === registrationState.EventRegistrations.length)
        ? setMaxRegistrationErrorState(
              <large className="text-danger">
                <h4>This event is full, call or email the event contact to be placed on a wait list!</h4>
                <p>
                  Contact Name: <b>{registrationState.EventContact}</b><br></br>
                  Contact Phone Number: <b>{registrationState.EventPhone}</b><br></br>
                  Contact Email: <b>{registrationState.EventEmail}</b><br></br>
                </p>
              </large>
          )
        : setMaxRegistrationErrorState(null);
    var maxreg = ((registrationState.EventMaxRegistrations > registrationState.EventRegistrations.length));

    var valid = (type && event && maxreg );
    if(valid)
      // use this to notify step4 that some changes took place and prompt the user to save again
      setRegistrationState(registrationState => ({...registrationState, sentEmail: false }));
    return valid;
  };
  const typeOptions = [
    { value: 'Camp', label: 'Camp' },
    { value: 'Class', label: 'Class' },
    { value: 'Club', label: 'Club' },
    { value: 'Event', label: 'Event' },
    { value: 'League', label: 'League' },
    { value: 'Tourney', label: 'Tourney' },
    { value: 'Training', label: 'Training' },
  ];
  // TODO: Migrate to @react-google-maps/api when needed
  // //Lets build Google Map URL const
  // const googleURL = "https://maps.googleapis.com/maps/api/js?key=" + rest.apiKeyGoogleCalendar;
  // const RegularMap = withScriptjs(
  //     withGoogleMap(props => (
  //         <GoogleMap
  //             defaultZoom={13}
  //             defaultCenter={{ lat: 39.390313 , lng: -104.591533 }}
  //             defaultOptions={{
  //               scrollwheel: false
  //             }}
  //         >
  //           <Marker position={{ lat: 39.390313 , lng: -104.591533 }} />
  //         </GoogleMap>
  //     ))
  // );
  //Lets build some date and time constants
  var StartDate = new Date(registrationState.EventStartDate);
  var EndDate = new Date(registrationState.EventEndDate);
  const startDate = StartDate.toLocaleDateString('en-US') + " @ " + StartDate.toLocaleTimeString('en-US');
  const endDate = EndDate.toLocaleDateString('en-US') + " @ " + EndDate.toLocaleTimeString('en-US');
  React.useImperativeHandle(ref, () => ({
    isValidated: () => {
      return isValidated();
    },
  }));
  //console.log(registrationState);
  return (
    <>
      <h5 className="info-text">
        Please select the event type and then the actual Event.
      </h5>
      <form>
      <div className="form-row">
        <FormGroup className="col-md-6">
          <p className="title"><b>Choose an Event Type </b><span className="text-danger">*</span></p>
          <Select
              className="react-select react-select-info"
              classNamePrefix="react-select"
              placeholder="What type of event are you registering for?"
              name="singleSelect"
              closeMenuOnSelect={true}
              value={registrationState.Type}
              onChange={handleTypeChange}
              options={typeOptions}
              clearable={false}
              deleteRemoves={false}
              backspaceRemoves={false}
              searchable={true}
          />
          {TypeError}
        </FormGroup>
        <FormGroup className="col-md-6">
          <p className="title"><b>Choose an Event </b><span className="text-danger">*</span></p>
          <Select
              className="react-select react-select-info"
              classNamePrefix="react-select"
              placeholder="Choose an Event"
              name="singleSelect"
              closeMenuOnSelect={true}
              value={registrationState.Event}
              onChange={handleEventChange}
              options={registrationState.eventsList}
              disabled={registrationState.EventListDisabled}
              clearable={false}
              deleteRemoves={false}
              backspaceRemoves={false}
              searchable={true}
          />
          {EventError}
        </FormGroup>
          {(registrationState.EventTitle !== "") ?
              <FormGroup className="col-md-12">
              <Card>
                <CardHeader>Event Details</CardHeader>
                <CardBody>
                  <Row>
                    <Col md={4} mdOffset={1} xs={4} xsOffset={4}>
                      <CardImg top src={registrationState.EventImage} alt="Event Image" />
                      <CardText>
                        <p>
                          <b>{registrationState.EventSubTitle}</b>
                          <br /><b>{registrationState.EventDescription}</b><br />
                        </p>
                      </CardText>
                    </Col>
                    <Col md={8} mdOffset={1} xs={4} xsOffset={4}>
                      <p>
                        Event Title: <b>{registrationState.EventTitle}</b><br></br>
                        Type: <b>{registrationState.EventType}</b><br></br>
                        Contact Name: <b>{registrationState.EventContact}</b><br></br>
                        Contact Phone Number: <b>{registrationState.EventPhone}</b><br></br>
                        Contact Email: <b>{registrationState.EventEmail}</b><br></br>
                        Event Location: <b>{registrationState.EventLocation}</b><br></br>
                        Event Start Date: <b>{startDate} MST</b><br></br>
                        Event End Date: <b>{endDate} MST</b><br></br>
                        Event Max Registrations: <b>{registrationState.EventMaxRegistrations}</b><br></br>
                        Event Current Registrations:
                        {(registrationState.EventMaxRegistrations <= registrationState.EventRegistrations.length) ?
                            <large className="text-danger"><b> {registrationState.EventRegistrations.length} - FULL</b><br></br></large>
                            :
                            <large className="text-primary"><b> Still Spots Available</b><br></br></large>
                        }
                        Event Price: <b>${registrationState.EventPrice}</b><br></br>
                        Event Age Restrictions: <b>{registrationState.EventAgeRestriction}</b><br></br>
                        Event Gender Restrictions: <b>{registrationState.EventGenderRestriction}</b><br></br>
                        Event "Younger Than" Restrictions: <b>{registrationState.EventYoungerThan}</b><br></br>
                        Referring Website: <b><a href={registrationState.EventOtherWebsite} target="_blank">{registrationState.EventOtherWebsite}</a></b><br></br>
                      </p>
                    </Col>
                  </Row>
                  {/* TODO: Migrate to @react-google-maps/api when needed */}
                  {/* <Row>
                    <Col md={12}>
                      <Card>
                          <CardHeader>The Deep VBC Location Map</CardHeader>
                          <CardText>
                            <RegularMap
                                googleMapURL={googleURL}
                                loadingElement={<div style={{ height: `100%` }} />}
                                containerElement={<div style={{ height: `400px` }} />}
                                mapElement={<div style={{ height: `100%` }} />}
                            />
                          </CardText>
                      </Card>
                    </Col>
                  </Row> */}
                {MaxRegistrationError}
                </CardBody>
              </Card>
              </FormGroup>
              :
              <div></div> }
      </div>
      </form>
    </>
  );
});

export default Step1;
